import { TextArea } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

import { useTypedSelector } from "../../../app/rootReducer";
import { useAppDispatch } from "../../../app/store";
import { useBusinessRule } from "../../../hooks/businessRule/useBusinessRule";
import { updateRequest } from "../../../slices/requestSlice";

const MAX_LENGTH = 1000;

export const ParentRemark = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const request = useTypedSelector((state) => state.request.request);
  const { isRequestDraft } = useBusinessRule();

  const handleParentRemarkChange = (value: string) => {
    dispatch(updateRequest({ ...request, parentRemark: value }));
  };

  if (!isRequestDraft() && !request.parentRemark) {
    return null;
  }

  return (
    <div className="mb-3">
      <TextArea
        label={t("request.parentRemark")}
        ariaLabel={t("request.parentRemark")}
        value={request.parentRemark || ""}
        onChange={(e) => handleParentRemarkChange(e.target.value)}
        maxLength={MAX_LENGTH}
        disabled={!isRequestDraft()}
        rows={4}
        helperText={`${(request.parentRemark || "").length} / ${MAX_LENGTH}`}
      />
    </div>
  );
};
